/**
 * ContadorDoAtendimento — o selo de respostas não lidas (D3, passo 19 — peça I do desenho do portal). Um componente, três lugares: o
 * item "Atendimento" do menu (desktop e overlay do celular), o botão "Menu" do celular e cada conversa da lista.
 * Verde-700 (5,5:1 com o branco) e NÃO o `UnreadBadge` navy/vermelho do chat: no portal não há menção e o vermelho é erro.
 * Não renderiza com 0. Quem usa decide a região viva (`role="status"` só no menu: uma lista de regiões vivas vira ruído).
 */
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface Props extends Omit<HTMLAttributes<HTMLSpanElement>, "children"> {
  total: number;
}

export function ContadorDoAtendimento({ total, className, ...resto }: Props) {
  if (!Number.isFinite(total) || total <= 0) return null;
  return (
    <span
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-emerald-700 px-1.5 text-xs font-semibold tabular-nums text-white",
        className
      )}
      {...resto}
    >
      {total > 99 ? "99+" : total}
    </span>
  );
}
